
<div
	ref="screenshot"
	class="flow-screenshot"
	:empty="state === -1"
	:inprogress="state === 0"
	:done="state === 1"
	:tabindex="tabindex"
	@click="handleClick($event)"
>
	<Icon
		v-if="state === -1"
		name="i-camera-1"
		type="filled"
		size="medium"
		state="dark"
		:effects="false"
	/>

	<Icon
		v-if="state === 0"
		name="i-loader"
		state="default"
		:animate="true"
		type="filled"
		:effects="false"
	/>
	<p v-if="state !== 1 && status" class="paragraph-1 fc-dark fw-300">
		{{ status }}
	</p>
	<img v-if="state === 1" :src="src" />
	<Button
		v-if="state === 1"
		state="icon"
		size="small"
		type="error"
		class="remove-screenshot"
		@click.stop="state = -1"
	>
		<Icon name="i-close" type="filled" size="x-small" state="black" :effects="false" />
	</Button>
</div>
